import styled from "styled-components";
import WithUiTag from "../../commons/components";

export const StyledShoppingCartIcon = WithUiTag("ShoppingCartIcon")(styled.div`
    font-family: "OpenSans", sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 32px;
    height: 32px;
    text-align: center;
    box-sizing: border-box;

    @media screen and (max-width: 640px) {
        width: calc(32px * 0.75);
        height: calc(32px * 0.75);
    }

    .cart-icon {
        z-index: 1;
        cursor: pointer;
        width: 75%;
        height: 75%;
    }

    .total-items {
        width: 20px;
        height: 19px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: -5px;
        right: -7px;
        z-index: 20;
        box-sizing: border-box;
        font-size: 0.75rem;
        font-weight: bold;
        color: #ffffff;
        background-color: #9e007e;

        @media screen and (max-width: 640px) {
            font-size: 0.6em;
            width: 16px;
            height: 15px;
            top: -5px;
            right: -6px;
        }
    }

    .timer {
        background: #fff;
        position: absolute;
        color: #000;
        font-weight: bold;
        z-index: 20;
        opacity: .8;
        top: 19px;
        left: -62px;
        box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
        display: flex;
        align-items: center;
        padding: 2px;
        border-radius: 8px;

        .text {
            font-size: 12px;
            white-space: nowrap;
            margin-right: 5px;
        }

        .time {
            font-size: 14px;
        }

        .time.warning {
            color: #d52525;
        }

        @media screen and (max-width: 640px) {
            top: 14px;
            left: -61px;

            .text {
                font-size: 11px;
            }

            .time {
                font-size: 12px;
            }
        }
    }
`);
